import { render, staticRenderFns } from "./AddToDoCourse.vue?vue&type=template&id=68b2dfcc&scoped=true"
import script from "./AddToDoCourse.vue?vue&type=script&lang=js"
export * from "./AddToDoCourse.vue?vue&type=script&lang=js"
import style0 from "./AddToDoCourse.vue?vue&type=style&index=0&id=68b2dfcc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b2dfcc",
  null
  
)

export default component.exports